'use client';

import { useContext } from 'react';

import { PostMemoContext } from './post-memo-provider';

import type { PostMemoContextValue } from './post-memo-provider';

/**
 * PostMemoProvider 하위에서 메모 상태·저장을 쓴다.
 * @throws provider 밖에서 부르면 `'usePostMemo는 PostMemoProvider 안에서만 사용할 수 있습니다.'`
 */
export function usePostMemo(): PostMemoContextValue {
  const ctx = useContext(PostMemoContext);
  if (ctx == null) {
    throw new Error('usePostMemo는 PostMemoProvider 안에서만 사용할 수 있습니다.');
  }
  return ctx;
}

/** provider 가 없으면 `null` — 표 셀처럼 «있으면 켜지는» 자리용 */
export function usePostMemoOptional(): PostMemoContextValue | null {
  return useContext(PostMemoContext);
}
